var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          staticClass: "mode",
          attrs: {
            "close-on-click-modal": false,
            "close-on-press-escape": false,
            "custom-class": "layout-dialog",
            title: "建物選択",
            top: "5vh",
            width: "1024px",
            visible: _vm.dialogVisible,
            "show-close": false,
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            opened: _vm.opened,
            close: _vm.close,
          },
        },
        [
          _c(
            "vab-query-form-mode",
            {
              staticClass: "dpform noborder",
              attrs: {
                model: _vm.queryForm,
                rules: _vm.rules,
                "enable-query-save": false,
                size: "mini",
                "label-position": "left",
                "label-width": "120px",
              },
              on: { search: _vm.onSearch },
            },
            [
              _c(
                "el-row",
                { attrs: { gutter: 30 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          label: "建物CD",
                          validate: "max:6",
                          maxlength: "6",
                          prop: "blgscd",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          label: "所属部課CD",
                          prop: "pstsctcd",
                          maxlength: "6",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 8 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          label: "得意先CD",
                          prop: "bcncd",
                          maxlength: "9",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          "label-width": "140px",
                          label: "建物名称カナ１(ｶﾅ)",
                          maxlength: "68",
                          prop: "blgsnmkn1",
                          validate: "halfKana",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          "label-width": "140px",
                          label: "建物名称カナ２(ｶﾅ)",
                          maxlength: "68",
                          prop: "blgsnmkn2",
                          validate: "halfKana",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          "label-width": "180px",
                          label: "所属部課名(半角ｶﾅ)",
                          maxlength: "35",
                          prop: "orgknnm",
                          validate: "halfKana",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c("vab-input", {
                        attrs: {
                          "label-width": "160px",
                          label: "得意先名(半角ｶﾅ)",
                          prop: "bcnknnm",
                          maxlength: "60",
                          validate: "halfKana",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-row",
            { staticClass: "m20" },
            [
              _c(
                "el-col",
                { attrs: { span: 24 } },
                [
                  _c("vab-table", {
                    ref: "table",
                    attrs: {
                      "api-url": "/api/mbuildgp/query",
                      columns: _vm.columns,
                      "custom-config": false,
                      "multi-select": _vm.multiSelect,
                      height: "300",
                      "query-params": _vm.queryForm,
                      "row-key": _vm.getRowKey,
                      "enable-init": false,
                    },
                    on: {
                      "update:queryParams": function ($event) {
                        _vm.queryForm = $event
                      },
                      "update:query-params": function ($event) {
                        _vm.queryForm = $event
                      },
                      "selection-change": _vm.setSelectRows,
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer flex_end",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "div",
                { staticClass: "flex_start flex_center_align" },
                [
                  _c(
                    "el-button",
                    { staticClass: "cancel", on: { click: _vm.close } },
                    [_vm._v("キャンセル")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function ($event) {
                          return _vm.save()
                        },
                      },
                    },
                    [_vm._v("確定")]
                  ),
                ],
                1
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }